import { Failure } from 'src/app/core/utils/failure';
import { ClaimMultiEntity } from '../entities/claim-multi.entity';
import { ClaimsPaginationParams } from '../entities/claim-pagination-params.entity';
import { MultiPagination } from '../entities/multi-pagination.entity';
import { UpdateClaimConciliatorEntity } from '../entities/update-claim-conciliator.entity';
import { GetFileEntity } from '../entities/get-file.entity';
import { UpdateClaimStatusEntity } from '../entities/update-claim-satus.entity';
import { DeleteClaimEntity } from '../entities/delete-claim.entity';

export abstract class ClaimMultiRepositoryBase {
  abstract getClaim(id: string): Promise<ClaimMultiEntity | Failure>;
  abstract createClaim(claim: ClaimMultiEntity): Promise<string | Failure>;
  abstract updateClaim(claim: ClaimMultiEntity): Promise<string | Failure>;
  abstract getMultiClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure>;
  abstract getAllFinishedClaims(
    params: ClaimsPaginationParams
  ): Promise<MultiPagination | Failure>;
  abstract updateClaimConciliator(
    claim: UpdateClaimConciliatorEntity
  ): Promise<string | Failure>;
  abstract getFile(params: GetFileEntity): Promise<string | Failure>;
  abstract updateClaimStatus(
    claim: UpdateClaimStatusEntity
  ): Promise<string | Failure>;
  abstract deleteClaim(
    deleteClaim: DeleteClaimEntity
  ): Promise<string | Failure>;
}
